import tw from 'tailwind-styled-components'

export const TwStickerHeader = tw.div`
  bg-background-primary
  text-14
  text-primary
  flex
  items-center
  w-full
`

export const TwStickerHeaderTitle = tw.div`
  font-semibold
  truncate
`

export const TwStickerMenu = tw.div`
  py-8
  bg-background-primary
`
